import logger from './logger';

/**
 * Console Interception Setup
 * 
 * This module intercepts all global console methods and routes them through
 * the logger while preserving the original console behavior.
 * 
 * All console.log, console.debug, console.info, console.warn, and console.error
 * calls throughout the application will automatically be captured by the logger.
 */

// Save original console methods before overriding
const originalConsole = {
    log: console.log.bind(console),
    debug: console.debug.bind(console),
    info: console.info.bind(console),
    warn: console.warn.bind(console),
    error: console.error.bind(console)
};

// Store reference for logger to use
logger._originalConsole = originalConsole;

/**
 * Override global console methods to intercept all console calls
 * Each override:
 * 1. Calls the logger (which adds to buffer and uses originalConsole)
 * 2. Returns to maintain any return values
 */
console.log = (...args) => {
    logger.log(...args);
};

console.debug = (...args) => {
    logger.debug(...args);
};

console.info = (...args) => {
    logger.info(...args);
};

console.warn = (...args) => {
    logger.warn(...args);
};

console.error = (...args) => {
    logger.error(...args);
};

// Log that console interception is active
originalConsole.info('[Console Interception] All console methods are now captured by logger');

export { originalConsole };
